<template>
  <ul class="tag-list">
    <li
      class="tag"
      v-for="tag in value">
      <router-link
        class="tag-inner"
        :to="tag.href"
        v-if="tag.href">
        {{ tag.name }}
      </router-link>

      <div
        class="tag-inner"
        v-else>
        {{ tag.name }}
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'tag-list',

    /**
     * @param {object[]} value - array of tags
     * @param {number}   value[].id
     * @param {string}   value[].name
     * @param {string}   value[].href - each tag can be a link
     */
    props: ['value'],

    data() {
      return {};
    }
  }
</script>

<style lang="scss" scoped>
  .tag-list {
    margin-top: 10px;
  }

  .tag {
    display: inline-block;

    > .tag-inner {
      background: transparent;
      border: solid 1px #33ccff;
      border-radius: 4px;
      color: #33ccff;
      display: inline-block;
      padding: 4px 8px;
      margin: 0 5px 10px 0;
      height: auto;
      font-size: 12px;
      &::before {
        content: '#'
      }
    }

    > a {
      &:hover {
        background-color: #33ccff;
        color: #222222;
        text-decoration: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?c313b80e